import { useEffect, useState } from 'react';
import classNames from 'classnames';

import useStyles from './style';
import { ISingleToolNavExtenstion } from './types';

const SingleToolNavigationExtension = ({
  currentMenu,
  name,
  subCategories,
  maxSize,
}: ISingleToolNavExtenstion) => {
  const classes = useStyles();
  const [unflattenCategories, setUnflattenCategories] = useState([]);

  useEffect(() => {
    const unflatten = [];
    const arrayCopy = [...subCategories];
    while (arrayCopy.length > 0) {
      unflatten.push(arrayCopy.splice(0, maxSize + 1));
    }
    setUnflattenCategories(unflatten);
  }, []);

  return (
    <div
      className={classNames(classes.navbarSubItems, classes.navbarSubItemsApp, {
        isMobileActive: currentMenu === name,
      })}
    >
      <div className={classes.borderLeft} />
      {unflattenCategories.map((appCategory, key) => {
        return (
          <ul key={key}>
            {appCategory.map((category) => {
              return (
                <li
                  key={category.label}
                  className={classNames(classes.navbarSubItem, classes.subCategoryItem)}
                >
                  <a href={category.href} className={classes.navbarSubItemLink}>
                    {category.label}
                  </a>
                </li>
              );
            })}
          </ul>
        );
      })}
    </div>
  );
};

export default SingleToolNavigationExtension;
